import { useAtom } from "jotai";
import { v4 as uuidv4 } from "uuid";

import CompanyInfo from "./components/CompanyInfo";
import LocationsContainer from "./components/LocationsContainer";
import BusinessHours from "./components/BusinessHours";
import globalState from "../../store";
import SocialMedia from "./components/SocialMedia";
import {
  borderedInputWhite,
  boxContainer,
  pageContainerWithOverflow,
} from "../../shared/styles";
import Announcement from "./components/Announcement/Announcement";
import HomepageKeywordFamily from "./components/KeywordFamily/HomepageKeywordFamily";
import {
  generateAboutUs,
  generateFaqs,
  generateMetadataDescription,
  generateMetadataTitle,
  generateTagline,
  regenerateServiceDescriptions,
} from "./components/Generate";
import { extractQuestionAndAnswer } from "../faqs/utils";
import { searchKeywordFamily } from "../../shared/utils";
import { useState } from "react";
import LoadingOverlay from "../../shared/LoadingOverlay";

const BasicInfoPage: React.FC = () => {
  const [globalStateAtom, setGlobalState] = useAtom(globalState);
  const [pageLoading, setPageLoading] = useState(false);


  const updateAllPrimaryInfoContent = async () => {
    try {
      setPageLoading(true);

      const newIndustryKeywords = await searchKeywordFamily(
        globalStateAtom.company_type || globalStateAtom?.industry_alias?.alias || "",
        true
      );
      const globalStateWithUpdatedKeywords = {
        ...globalStateAtom,
        primary_keyword: newIndustryKeywords.primary_keyword,
        keywords: newIndustryKeywords.keywords,
      };

      const [
        company_tagline,
        about,
        meta_description,
        title_tag,
        faqs,
        services,
      ] = await Promise.all([
        generateTagline(globalStateWithUpdatedKeywords),
        generateAboutUs(globalStateWithUpdatedKeywords),
        generateMetadataDescription(globalStateWithUpdatedKeywords),
        generateMetadataTitle(globalStateWithUpdatedKeywords),
        Promise.all(
          new Array(globalStateAtom.faqs.length).fill(null).map((_, index) =>
            generateFaqs(globalStateAtom)
              .then((response) => extractQuestionAndAnswer(response))
              .then((questionAndAnswer) => ({
                ...questionAndAnswer,
                "landing-page": globalStateAtom.sitePk,
                order: index,
                draggableId: uuidv4(),
              }))
          )
        ),
        regenerateServiceDescriptions(globalStateAtom),
      ]);

      setGlobalState({
        ...globalStateAtom,
        primary_keyword: newIndustryKeywords.primary_keyword,
        keywords: newIndustryKeywords.keywords,
        company_tagline,
        about,
        title_tag,
        meta_description,
        faqs,
        services,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setPageLoading(false);
    }
  };

  return (
    <div className={pageContainerWithOverflow}>
      <LoadingOverlay loading={pageLoading}>
        <HomepageKeywordFamily />
      </LoadingOverlay>
      <div className="flex flex-wrap">
        <LoadingOverlay loading={pageLoading} className={boxContainer}>
          <CompanyInfo onUpdateContentClick={updateAllPrimaryInfoContent} />
        </LoadingOverlay>
        <div className={boxContainer}>
          <h2>Business Hours</h2>
          <BusinessHours />
          <div className="mt-12 bg-white py-2 px-4 rounded-md">
            <label>
              CompanyCam widget code for Home Page:
              <textarea
                className={borderedInputWhite}
                onChange={(e) =>
                  setGlobalState({
                    ...globalStateAtom,
                    home_cc_widget: e.target.value,
                  })
                }
                value={globalStateAtom.home_cc_widget}
                cols={10}
                rows={5}
              ></textarea>
            </label>
          </div>
          <Announcement />
        </div>
        <div className="flex">
          <LocationsContainer />
          <SocialMedia />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoPage;
